import { Navigate } from 'react-router-dom';

import { useStore } from '../store';

import { AuthSkeleton } from './AuthSkeleton';

/** `/` → the lobby when signed in, the login screen otherwise. */
export function RootRedirect() {
  const status = useStore((s) => s.auth.status);

  if (status === 'hydrating') return <AuthSkeleton />;
  return <Navigate to={status === 'authenticated' ? '/lobby' : '/login'} replace />;
}
